import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { CheckoutPlaceOrderComponent } from '@spartacus/checkout/base/components';
import {
  CheckoutReplenishmentFormService,
  CheckoutScheduledReplenishmentPlaceOrderComponent,
} from '@spartacus/checkout/scheduled-replenishment/components';
import { RoutingService, UrlPipe, TranslatePipe } from '@spartacus/core';
import { LaunchDialogService } from '@spartacus/storefront';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { OrderFacade, ScheduledReplenishmentOrderFacade } from '@spartacus/order/root';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'cx-place-order',
    templateUrl: './kn-br-place-order.component.html',
    styleUrls: ['./kn-br-place-order.component.scss'],
    imports: [ReactiveFormsModule, RouterLink, AsyncPipe, UrlPipe, TranslatePipe]
})
export class KnBrPlaceOrderComponent
  extends CheckoutScheduledReplenishmentPlaceOrderComponent
  implements OnInit, OnDestroy
{
  checkoutSubmitForm: FormGroup = this.fb.group({
    termsAndConditions: [true, Validators.requiredTrue],
  });
  subscriprion = new Subscription();
  disablePlaceOrder = false;
  isASMLoggedIn$: Observable<boolean> = this.csAgentAuthService.isCustomerSupportAgentLoggedIn();
  constructor(
    protected checkoutService: OrderFacade,
    protected routingService: RoutingService,
    protected fb: FormBuilder,
    protected launchDialogService: LaunchDialogService,
    protected vcr: ViewContainerRef,
    protected checkoutReplenishmentFormService: CheckoutReplenishmentFormService,
    protected cdr: ChangeDetectorRef,
    protected scheduledReplenishmentOrderFacade: ScheduledReplenishmentOrderFacade,
    protected csAgentAuthService: CsAgentAuthService
  ) {
    // tslint:disable-next-line: max-line-length
    super(
      checkoutService,
      routingService,
      fb,
      launchDialogService,
      vcr,
      checkoutReplenishmentFormService,
      scheduledReplenishmentOrderFacade
    );
  }
  //  Need to Discuss
  ngOnInit(): void {
    // super.ngOnInit();
    // this.subscriprion.add(
    //   combineLatest([
    //     this.checkoutService.getPlaceOrderLoading(),
    //     this.checkoutService.getPlaceOrderSuccess(),
    //     this.checkoutService.getPlaceOrderError(),
    //   ]).subscribe(([orderLoading, orderSuccess, orderError]) => {
    //     if (orderLoading) {
    //       this.disablePlaceOrder = true;
    //       this.cdr.markForCheck();
    //     }
    //     if (orderError) {
    //       this.disablePlaceOrder = false;
    //       this.cdr.markForCheck();
    //     }

    //     if (orderSuccess) {
    //       this.disablePlaceOrder = false;
    //       this.cdr.markForCheck();
    //     }
    //   })
    // );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.subscriprion.unsubscribe();
  }
}
